import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatBoolean from "go-core/components/Formatters/FormatBoolean";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { PartnerSummaryApi } from "../../../../../services/Api/Partner/partnerTypes";
import PayoffTable from "./PayoffTable";

interface Props {
	payoff: PartnerSummaryApi;
	fetchPayoff: () => Promise<void>;
	isAdminMode: boolean;
}

const PayoffInfo = ({ payoff, fetchPayoff, isAdminMode }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<div className="d-flex flex-column" style={{ maxWidth: "966px" }}>
			<Card className={"mb-3"}>
				<Card.Body>
					<h5>{t("lib:common.word.informations")}</h5>
					<div className="card-body-item">
						<div className="item-info">
							<span className="label">{t("modules.payoff.field.provision_sum.title")}</span>
							<span>{FormatMoney(payoff.provision_value)}</span>
						</div>
					</div>
					<div className={"card-body-item"}>
						<div className="item-info">
							<span className="label">{t("modules.payoff.field.email_sent.title")}</span>
							<span>
								<FormatBoolean value={payoff.email_sent} />
							</span>
						</div>
					</div>
				</Card.Body>
			</Card>
			<PayoffTable payoff={payoff} fetchPayoff={fetchPayoff} isAdminMode={isAdminMode} />
		</div>
	);
};
export default PayoffInfo;
